<div class="d-flex flex-row flex-wrap">
  <div class="position-relative m-2" style="width: 150px; height: 150px;" *ngFor="let image of images">
    <img [src]="image.image_url" [alt]="image.original_file_name" class="img-thumbnail w-100 h-100" style="object-fit: cover;">
    <a [href]="image.image_url" target="_blank" rel="noopener noreferrer"
      class="position-absolute btn btn-primary btn-sm rounded-circle"
      style="top: 5px; right: 5px; ">
      <i class="la la-external-link-alt" ></i>
    </a>
    <button *ngIf="editable" type="button"
      class=" position-absolute btn btn-danger btn-sm rounded-circle"
      style="top: 5px; left: 5px; "
      (click)="deleteImage(image)"
      [disabled]="isDeleting(image.id)">
      <i *ngIf="!isDeleting(image.id)" class="la la-fw la-trash" aria-hidden="true" ></i>
      <i *ngIf="isDeleting(image.id)" class="la la-spin la-cog" ></i>
    </button>
  </div>
  <app-loader *ngIf="isLoading"></app-loader>
</div>
